var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "loading" }, [
    _c("div", { staticClass: "loading-spinner" }),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.loadingText))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }